import {isBlank, isValidString} from './stringUtils';
import {getWindowWebOSApi} from './windowUtils';

// Declaration merging to extend the Window interface with WebOS API
// see: https://webostv.developer.lge.com/develop/references/webostvjs-webos
declare global {
  interface Window {
    /**
     * @deprecated In webOS TV 4.x or lower, only PalmSystem is supported, and in webOS TV 5.0 or higher,
     * both PalmSystem and webOSSystem are supported. Although PalmSystem is still supported for backward compatibility,
     * future support is not guaranteed so it is strongly recommended that you use webOSSystem in webOS TV 5.0 or higher.
     *
     * @see https://webostv.developer.lge.com/develop/guides/app-lifecycle-management
     */
    PalmSystem?: {
      deviceInfo?: string;
    };

    /**
     * Represents the current system interface that should be used on webOS TV 5.0 or higher.
     *
     * @see https://webostv.developer.lge.com/develop/references/webostvjs-webos
     */
    webOSSystem?: {
      /**
       * @see https://webostv.developer.lge.com/develop/references/webostvjs-webos#deviceinfo
       */
      deviceInfo?: string;
    };
  }
}

type WebOSDeviceInfo = {modelName: string};

export function getWebOSTVModelName(): string | undefined {
  try {
    const {webOSSystem, PalmSystem} = getWindowWebOSApi();
    const info: WebOSDeviceInfo | undefined = webOSSystem?.deviceInfo
      ? JSON.parse(webOSSystem.deviceInfo)
      : PalmSystem?.deviceInfo && JSON.parse(PalmSystem.deviceInfo);
    if (isValidString(info?.modelName) && !isBlank(info?.modelName)) {
      return info.modelName;
    }
    return undefined;
  } catch {
    return undefined;
  }
}
